import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import AccountPagesWrapper from '../../components/Account/PageWrapper';
import { ROUTES, notification } from '../../assets/constants/strings';
import { activateProduct } from '../../services/axios';
import { logIn } from '../../store/User/userActions';
import { hasDeveloperApi, isSuperAdmin, isAuthenticated } from '../../services/entitlements';

/**
 * Shown when a logged-in account WITHOUT the DeveloperApi entitlement lands in
 * the /api portal. Instead of bouncing them back to the reader, offer to add
 * the Developer API (free tier) to their EXISTING account — one account, one
 * subscription per product. Never make them sign up again.
 */
const ApiActivatePage = ({ user, logIn }) => {
  const [activating, setActivating] = useState(false);

  const IsLoggedIn = localStorage.getItem('loggedIn') === 'true';

  // Not logged in (falsy, or the reducer's truthy "logged out" sentinel which has no token) and no
  // stored session → log in through the API funnel first. This also catches post-logout, when other
  // API pages bounce here.
  if (!isAuthenticated(user) && !IsLoggedIn)
    return <Redirect to={`${ROUTES.LOGIN}?portal=api`} />;

  // Already entitled (also fires right after a successful activation, once the
  // refreshed auth state lands) → straight to the portal.
  if (user && hasDeveloperApi(user)) return <Redirect to={ROUTES.APIHOME} />;

  // A pure SuperAdmin (internal, no Developer API of their own) shouldn't be asked to "activate"
  // the API as if they were a customer — send them to the admin console instead.
  if (user && isSuperAdmin(user)) return <Redirect to={ROUTES.APIAdmin} />;

  const handleActivate = async () => {
    setActivating(true);

    const res = await activateProduct('DeveloperApi');

    if (res && res.succeeded) {
      // Refresh the auth state through the refresh-token flow so the new
      // entitlement lands in the JWT + user object; the redirect above fires.
      await logIn(null, null);
    } else {
      notification(
        'error',
        res && res.message ? res.message : 'Could not activate the Developer API.'
      );
      setActivating(false);
    }
  };

  return (
    <AccountPagesWrapper>
      <div className='wf-account__card login'>
        <h2 className='mb-3'>Add the Developer API to your account</h2>
        <p>
          Your RegulationCity account does not include the Developer API yet.
          Activate the free tier to explore the API — your reader subscription
          is not affected, and you can manage each product separately.
        </p>
        <Button
          variant='primary'
          className='w-100 mt-3'
          disabled={activating}
          onClick={handleActivate}
        >
          {activating ? 'Activating…' : 'Activate Developer API — Free'}
        </Button>
        <div className='text-center mt-3'>
          <a href={ROUTES.HOME}>Back to the Reader app</a>
        </div>
      </div>
    </AccountPagesWrapper>
  );
};

const mapStateToProps = (state) => ({
  user: state.user.user,
});

const mapDispatchToProps = { logIn };

export default connect(mapStateToProps, mapDispatchToProps)(ApiActivatePage);
